import { render } from "./DiabeteDetails.vue?vue&type=template&id=077f1993"
import script from "./DiabeteDetails.vue?vue&type=script&lang=js"
export * from "./DiabeteDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__